<template>
    <div class="loading-spinner">
        <div
            v-for="n in 3"
            :key="n"
            :class="`ball bounce${n}`"
            :style="{ backgroundColor: color }"
        />
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',
    props: {
        color: {
            type: String,
            default: '#fff',
        },
    },
};
</script>

<style lang="scss" scoped>
.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
}
.loading-spinner > .ball {
    width: 14px;
    height: 14px;
    margin: 0 3px;
    background-color: #fff;
    border-radius: 100%;
    animation: bouncedelay 1s infinite ease-in-out both;
}
.loading-spinner .bounce1 {
    animation-delay: -0.3s;
}
.loading-spinner .bounce2 {
    animation-delay: -0.15s;
}
@keyframes bouncedelay {
    0%,
    100% {
        transform: scale(0);
    }
    50% {
        transform: scale(1);
    }
}
</style>
